module.exports = __webpack_public_path__ + "static/media/Artboard8.2dcc3e25.png";